




















































































































































































































































import { Watch, Prop, Component, Vue } from 'vue-property-decorator'
import { vxm } from '@/store'
import { accessContext } from '@/eostransit'
import AccountsTable from '@/components/accounts/AccountsTable.vue'
import SimpleTile from '@/components/common/SimpleTile.vue'
const numeral = require('numeral')

@Component({
  components: {
    AccountsTable,
    SimpleTile
  }
})
export default class UserDetails extends Vue {
  // props
  @Prop() private account!: string

  // data
  private loading: boolean = false
  private numeral = numeral
  private tableView: boolean = true

  // computed
  get wallet() {
    let w = vxm.transit.wallet
    if (w.auth) return w
    else return { auth: { accountName: '' } }
  }

  get isAuthenticated() {
    return (
      vxm.transit.walletState.authenticated &&
      !vxm.transit.walletState.authenticationError
    )
  }

  get isUser() {
    return (
      this.isAuthenticated &&
      vxm.transit.currentUser.accountName === this.account
    )
  }

  get accountTable() {
    return vxm.dappservices.accountTable
  }

  get userPkgSelection() {
    return this.accountTable.filter((pkg: any) => {
      return pkg.account === this.account
    })
  }

  get dappBalance() {
    return vxm.user.userDappLiquid
  }

  get refundReq() {
    return vxm.user.refundReq
  }

  get unstaking() {
    return vxm.user.unstaking
  }

  get staked() {
    return vxm.user.staked
  }

  get dapphdlData() {
    return vxm.user.userDapphdlData
  }

  get totalDappBalance() {
    return this.dappBalance + this.staked + this.unstaking + this.refundReq
  }

  // method
  refreshDapphdl() {
    vxm.alerts.setAlert({
      show: true,
      dismissible: false,
      title: 'Refreshing DAPPHDL...',
      message: 'To refresh DAPPHDL please allow this action in your wallet.',
      variant: 'warning'
    })
    this.wallet.eosApi
      .transact(
        {
          delay_sec: vxm.core.settings.txDelaySec,
          actions: [
            {
              account: 'dappairhodl1',
              name: 'refresh',
              authorization: [
                {
                  actor: this.wallet.auth.accountName,
                  permission: this.wallet.auth.permission
                }
              ],
              data: {
                owner: this.wallet.auth.accountName
              }
            }
          ]
        },
        {
          broadcast: true,
          blocksBehind: 3,
          expireSeconds: 60
        }
      )
      .then((resp: any) => {
        vxm.alerts.setAlert({
          show: true,
          dismissible: true,
          title: 'Successfully Refreshed!',
          message: 'DAPPHDL Resources successfully refreshed.',
          variant: 'success',
          txId: resp.transaction_id,
          dismissSecs: 6,
          dismissCountDown: 6
        })
        this.updateDetails()
      })
      .catch((error: any) => {
        vxm.alerts.setAlert({
          show: true,
          dismissible: true,
          title: 'Error while Refreshing!',
          message: 'Something went wrong: ' + error.message,
          variant: 'danger',
          dismissSecs: 8,
          dismissCountDown: 8
        })
        this.updateDetails()
      })
  }

  async updateDetails() {
    await vxm.user.getDappLiquid({ account: this.account, currentUser: false })
    await vxm.user.getStakingTable({
      account: this.account,
      currentUser: false
    })
    await vxm.user.getRefundTable({ account: this.account, currentUser: false })
    await vxm.user.getDapphdlData({ account: this.account, currentUser: false })
  }

  @Watch('account')
  async onAccountChange(val: any, oldVal: any) {
    this.loading = true
    await this.updateDetails()
    this.loading = false
  }

  @Watch('accountTable')
  async onAccountTableChange(val: any, oldVal: any) {
    await this.updateDetails()
  }

  // Lifecycle hooks
  async created() {
    this.loading = true
    await this.updateDetails()
    this.loading = false
  }
  mounted() {}
  updated() {}
  beforeDestroy() {}
  destroyed() {}
}
